<template>
  <v-expansion-panel-content>
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="12" xl="12" style="text-align: end;">
        <v-btn
          rounded
          dark
          class="common-botton"
          @click="$emit('changeTab', 2)"
        >
          <span style="padding-right: 11%;">
            Editar
          </span>
          <v-icon rigth>
            mdi-pencil
          </v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="4" md="3" lg="3" xl="3">
        <span class="text-header-data">
          Estatus
        </span>
        <br />
        <v-btn rounded dark style="background-color: #f1c21b;" :elevation="0">
          <span class="text-data-details" style="color:white;">
            {{ getStatusName(cuentaData.status) }}
          </span>
        </v-btn>
      </v-col>
      <v-col cols="12" sm="4" md="3" lg="3" xl="3">
        <span class="text-header-data">
          Canal
        </span>
        <br />
          <span class="text-data-details">
          {{ cuentaData.canal ? cuentaData.canal : 'No disponible' }}
          </span>
      </v-col>
      <v-col cols="12" sm="4" md="3" lg="3" xl="3">
        <span class="text-header-data">
          Ramo
        </span>
        <br />
          <span class="text-data-details">
            {{ cuentaData.ramo ? cuentaData.ramo : 'No disponible' }}
          </span>
      </v-col>
      <v-col cols="12" sm="4" md="3" lg="3" xl="3">
        <span class="text-header-data">
          Campaña
        </span>
        <br />
          <span class="text-data-details">
            {{ cuentaData.campania ? cuentaData.campania : 'No disponible' }}
          </span>
      </v-col>
      <v-col cols="12" sm="4" md="3" lg="3" xl="3">
        <span class="text-header-data">
          Empresa
        </span>
        <br />
          <span class="text-data-details">
            {{ cuentaData.empresa ? cuentaData.empresa : 'No disponible' }}
          </span>
      </v-col>
      <v-col cols="12" sm="4" md="3" lg="3" xl="3">
        <span class="text-header-data">
          Aseguradora
        </span>
        <br />
          <span class="text-data-details">
            {{ cuentaData.aseguradoraId ? getAseguradoraNameById(cuentaData.aseguradoraId) : "No disponible" }}
          </span>
      </v-col>
      <v-col cols="12" sm="4" md="3" lg="3" xl="3">
        <span class="text-header-data">
          Tipificación
        </span>
        <br />
          <span class="text-data-details">
            {{ cuentaData.tipificacion ? cuentaData.tipificacion : 'No disponible' }}
          </span>
      </v-col>
      <v-col cols="12" sm="4" md="3" lg="3" xl="3">
        <span class="text-header-data">
          Motivo
        </span>
        <br />
          <span class="text-data-details">
            {{ cuentaData.motivo ? cuentaData.motivo : 'No disponible' }}
          </span>
      </v-col>
      <v-col cols="12" sm="4" md="3" lg="3" xl="3">
        <span class="text-header-data">
          Servicio IVR
        </span>
        <br />
          <span class="text-data-details">
            {{ cuentaData.servicioIvr ? cuentaData.servicioIvr : 'No disponible' }}
          </span>
      </v-col>
      <v-col cols="12" sm="4" md="3" lg="3" xl="3">
        <span class="text-header-data">
          Agente
        </span>
        <br />
          <span class="text-data-details">
            {{ agenteNombre ? agenteNombre : 'No disponible' }}
          </span>
      </v-col>
      <v-col cols="12" sm="4" md="3" lg="3" xl="3">
        <span class="text-header-data">
          Plantilla
        </span>
        <br />
          <span class="text-data-details">
            {{ cuentaData.plantilla ? cuentaData.plantilla : 'No disponible' }}
          </span>
      </v-col>
      <v-col cols="12" sm="4" md="3" lg="3" xl="3">
        <span class="text-header-data">
          Plantilla ECI
        </span>
        <br />
          <span class="text-data-details">
            {{ plantillaECI ? plantillaECI : 'No disponible' }}
          </span>
      </v-col>
      <v-col cols="12" sm="4" md="3" lg="3" xl="3">
        <span class="text-header-data">
          Cuenta Correo
        </span>
        <br />
          <span class="text-data-details">
            {{ cuentaCorreo ? cuentaCorreo : 'No disponible' }}
          </span>
      </v-col>
      <v-col cols="12" sm="4" md="3" lg="3" xl="3">
        <span class="text-header-data">
          Documentos Solicitados
        </span>
        <br />
          <span class="text-data-details">
            {{ cuentaData.documentos_solicitados ? cuentaData.documentos_solicitados : 'No disponible' }}
          </span>
      </v-col>
      <v-col cols="12" sm="4" md="3" lg="3" xl="3">
        <span class="text-header-data">
          SLA
        </span>
        <br />
          <span class="text-data-details">
            {{ cuentaData.sla ? cuentaData.sla : 'No disponible' }}
          </span>
      </v-col>
      <v-col cols="12" sm="4" md="3" lg="3" xl="3">
        <span class="text-header-data">
          Toque 1
        </span>
        <br />
          <span class="text-data-details">
            {{ cuentaData.toque_1 ? cuentaData.toque_1 : 'No disponible' }}
          </span>
      </v-col>
      <v-col cols="12" sm="4" md="3" lg="3" xl="3">
        <span class="text-header-data">
          Toque 2
        </span>
        <br />
          <span class="text-data-details">
            {{ cuentaData.toque_2 ? cuentaData.toque_2 : 'No disponible' }}
          </span>
      </v-col>
      <v-col cols="12" sm="4" md="3" lg="3" xl="3">
        <span class="text-header-data">
          Toque 3
        </span>
        <br />
          <span class="text-data-details">
            {{ cuentaData.toque_3 ? cuentaData.toque_3 : 'No disponible' }}
          </span>
      </v-col>

      
    </v-row>
  </v-expansion-panel-content>
</template>

<script>
import { getAgenteById } from "@/services/user/user.service";
import { getPlantillaById } from "@/services/plantillasECI/plantillaECI.service";
import {getCuentaCorreoById} from "@/services/cuentasCorreo/cuentasCorreo.service.js";
import { mainAxios } from '@/mainAxios.js';
export default {
  components: {},
  props: {
    cuentaData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      polizaId: this.$route.params.id,
      tabReplace: 1,
      tiposCuenta: [],
      cuentaCorreo:"",
      statusList: [],
      agenteNombre: '',
      status: [
        { label: "Activo", value: 1 },
        { label: "Inactivo", value: 2 },
        { label: "Baja", value: 3 },
      ],
      plantillaECI:'',
      aseguradorasList: [],
    };
  },

  methods: {
    getStatusName(id) {
      return this.status.find((e) => e.value == id).label;
    },
    async getAgenteById(id) {
          const response = await getAgenteById(id);
          this.agenteNombre = [response.nombre, response.apellidoPaterno, response.apellidoMaterno].filter(Boolean).join(" ") || "No disponible";
    },

    getAseguradoras() {
      const config = {
        headers: {
          Authorization: "Bearer " + localStorage.agenteAccessToken,
        },
      };
      mainAxios.get("/v1/aseguradora/list", config).then((response) => {
        response.data.map((element) => {
          this.aseguradorasList.push({
            nombre: `${element.nombre}`,
            id: element.id,
            uuid: element.uuid,
          });
        });
      });
    },

    getAseguradoraNameById(id) {
      const aseguradora = this.aseguradorasList.find(item => item.id === id);
      return aseguradora ? aseguradora.nombre : 'Aseguradora no encontrada';
    },

    async getPlantillaECIById(id){
      const response = await getPlantillaById(id);
      this.plantillaECI = response.asunto;
    },
    async getCuentaCorreoById(id) {
      const response = await getCuentaCorreoById(id);
      this.cuentaCorreo = response.cuenta;
    }
  },
  mounted() {
    this.getAseguradoras();
    this.getAseguradoraNameById();
  },
  watch: {
    'cuentaData.agenteId': {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.getAgenteById(newVal);
        }
      }
    },
    'cuentaData.plantillasEciId':{
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.getPlantillaECIById(newVal);
        }
      }
    },
    'cuentaData.cuenta_correo_id':{
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.getCuentaCorreoById(newVal);
        }
      }
    },
  }
};
</script>

<style scoped>
.theme--light.v-data-table {
  background-color: #81cfe61a;
  color: rgba(0, 0, 0, 0.87);
  border-radius: 20px;
}

.v-expansion-panel {
  border-radius: 20px;
}
.v-expansion-panels {
  z-index: auto !important;
}
.v-expansion-panels:not(.v-expansion-panels--accordion):not(.v-expansion-panels--tile)
  > .v-expansion-panel--active {
  border-radius: 20px !important;
}

.theme--light.v-expansion-panels .v-expansion-panel {
  background-color: #81cfe61a;
  color: rgba(0, 0, 0, 0.87);
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.v-item-group .theme--light .v-expansion-panels {
  padding: 30px;
  border-radius: 20px;
  padding-left: 0 !important;
  padding-right: 0 !important;
}
</style>
